import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { VideoComponent } from './video/video.component';
import { TurbotaxComponent } from './turbotax/turbotax.component';
import { LastpassComponent } from './lastpass/lastpass.component';
import { SnapComponent } from './snap/snap.component';
import { HellosignComponent } from './hellosign/hellosign.component';
import { JitbComponent } from './jitb/jitb.component';
import { MintComponent } from './mint/mint.component';
import { ExperianComponent } from './experian/experian.component';
import { LivelyComponent } from './lively/lively.component';
import { BluelandComponent } from './blueland/blueland.component';
import { DlaComponent } from './dla/dla.component';
import { DinelaComponent } from './dinela/dinela.component';
import { AttComponent } from './att/att.component';
import { OpiComponent } from './opi/opi.component';
import { Kfp3Component } from './kfp3/kfp3.component';
import { TntComponent } from './tnt/tnt.component';
import { TbsComponent } from './tbs/tbs.component';
import { FjComponent } from './fj/fj.component';
import { EteComponent } from './ete/ete.component';
import { ToyotaComponent } from './toyota/toyota.component';


const routes: Routes = [

  {
    path: 'video',
    component: VideoComponent,
    children: [
      { path: 'turbotax', component: TurbotaxComponent },
      { path: 'lastpass', component: LastpassComponent },
      { path: 'snap', component: SnapComponent },
      { path: 'hellosign', component: HellosignComponent },
      { path: 'jitb', component: JitbComponent },
      { path: 'mint', component: MintComponent },
      { path: 'experian', component: ExperianComponent },
      { path: 'lively', component: LivelyComponent },
      { path: 'blueland', component: BluelandComponent },
      { path: 'dla', component: DlaComponent },
      { path: 'dinela', component: DinelaComponent },
      { path: 'att', component: AttComponent},
      { path: 'opi', component: OpiComponent},
      { path: 'kfp3', component: Kfp3Component },
      { path: 'tnt', component: TntComponent },
      { path: 'tbs', component: TbsComponent },
      { path: 'fj', component: FjComponent },
      { path: 'ete', component: EteComponent },
      { path: 'toyota', component: ToyotaComponent },
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class VideoRoutingModule { } 